import { Fragment, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { CloseIcon } from "../atoms/Icons";
import { useState } from "react";
import Link from "next/link";
import { ButtonElement } from "../atoms/Buttons";
import { prefix } from "../../utils/utils";
export default function DrawerChooseLocation({
  open,
  setOpen,
  regions,
  global_link,
  translations,
  websiteType,
}) {
  const locations = regions ? regions : [];
  const [selectedLocation, setSelectedLocation] = useState(null);
  useEffect(() => {
    if (locations.length > 0 && open) {
      setSelectedLocation(locations[0].id);
    }
  }, [locations, open]);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="background-overlay fixed inset-0 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen 640:max-w-[736px]">
                  <div className="flex h-full flex-col overflow-y-scroll bg-gray-200 divide-y divide-mediumGray">
                    <div className="relative flex flex-col gap-y-24 min-h-0 flex-1 overflow-y-auto p-16 640:p-24">
                      <div className="min-h-50 flex flex-row justify-between items-center">
                        <span className="text-m 640:text-l leading-125 tracking-05 640:leading-120 640:tracking-00 font-medium">
                          {translations?.choose_your_country}
                        </span>
                        <button
                          type="button"
                          className="fixed z-50 top-24 right-24 p-12 bg-gray-100 text-gray-900 border border-solid border-gray-300 media-hover:hover:bg-white rounded-xxxs duration-300"
                          onClick={() => setOpen(false)}
                          aria-label="Close"
                        >
                          <CloseIcon />
                        </button>
                      </div>
                      <div className="flex flex-col gap-y-24">
                        {/* Content */}
                        <ul className="relative flex gap-x-24 items-center w-full overflow-x-auto overflow-y-hidden border-b border-solid border-gray-300">
                          {locations.length > 0 &&
                            locations.map((location, index) => (
                              <li
                                key={index}
                                className={`border-b-2 border-transparent media-hover:hover:border-gray-900 duration-300 ${
                                  location.id === selectedLocation
                                    ? "border-b-2 !border-gray-900"
                                    : "text-gray-700 border-b-2 border-transparent"
                                }`}
                              >
                                <button
                                  type="button"
                                  className={`py-14 text-xxs font-medium leading-115 tracking-05 whitespace-nowrap`}
                                  onClick={() =>
                                    setSelectedLocation(location.id)
                                  }
                                  aria-label={location.title || ""}
                                >
                                  {location.title}
                                </button>
                              </li>
                            ))}
                        </ul>
                        <ul className="column-container flex-grow">
                          {locations.length > 0 &&
                            locations.map(
                              (location) =>
                                selectedLocation === location.id &&
                                location.country.length > 0 &&
                                location.country.map((c, index) => (
                                  <li className="column-item" key={index}>
                                    <div className="flex gap-x-16 items-center">
                                      <span className="text-xxs font-medium leading-115 tracking-05">
                                        {c.title}
                                      </span>
                                      {c.website.length > 0 &&
                                        c.website.map(
                                          (w, index) =>
                                            w.link && (
                                              <Link
                                                href={prefix(w.link)}
                                                as={prefix(w.link)}
                                                onClick={() => {
                                                  setOpen(false);
                                                }}
                                                target="_self"
                                                key={index}
                                                aria-label={w.title || ""}
                                                className="text-xxxs tracking-05 text-gray-700 border-b border-gray-700 media-hover:hover:border-transparent duration-300"
                                              >
                                                {w.title}
                                              </Link>
                                            ),
                                        )}
                                    </div>
                                  </li>
                                )),
                            )}
                        </ul>
                        {websiteType !== "petrotec-group" && (
                          <div>
                            <ButtonElement
                              label="Petrotec Group"
                              size="default"
                              variant="secondary"
                              type="special"
                              externallink="region_selection_drawer"
                              extraClass="mt-16 flex-row-reverse"
                              isEditor={false}
                              groupWebsiteLink={global_link ? global_link : "#"}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
